import { GET_TRYST_HOST } from "../constants/env";
import fetch from "../fetch-client";
import { TrystGenericResponse } from "../types/tryst";

export default async function sendBusinessReceiptWAMessage({
  receiptId,
}: {
  receiptId: number;
}): Promise<TrystGenericResponse<undefined>> {
  try {
    const TRYST_HOST = GET_TRYST_HOST();

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const requestOptions: RequestInit = {
      method: "PUT",
      headers: myHeaders,
      redirect: "follow",
      credentials: "include",
      mode: "cors",
    };

    const response = await fetch(
      `${TRYST_HOST}/business/receipt/${receiptId}/send-to-wa`,
      requestOptions
    );
    return await response.json();
  } catch (error) {
    return { success: false };
  }
}
